// 判断是否在登录页，如果不在则跳转到登录页
export const goToLogin = () => {
    const currentPath = window.location.href;
    const currentPathname = window.location.pathname;
    
    // 如果当前 URL 已经是 login 页面，直接跳转（不需要 redirect 参数）
    if (currentPathname === '/login' || currentPathname.startsWith('/login')) {
        return;
    }
    
    // 如果不是 login 页面，获取当前 URL 并放到 redirect 参数中
    window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
};